import {FAILURE, PENDING, SUCCESS} from '../../constants'
import {getDisplayFields as getDisplayFieldsApi} from '../../../services/shareableCalendarViews'

export async function getDisplayFields(dispatch, group_id, params) {
  try {
    dispatch({type: PENDING})
    let response = await getDisplayFieldsApi(group_id, params)
    dispatch({type: SUCCESS, payload: response})
    return response
  } catch (e) {
    console.log(`Create Calendar View Failed: ${group_id}`)
    dispatch({type: FAILURE, payload: e})
    return Promise.reject(e)
  }
}
